import axios from 'axios'
import {apiURL} from "@/api/config";

let fullExcelUrl = `${apiURL}file`;
let fileName = 'CMS회원가입신청서.pdf';


export const runFileDown = async (params) => {
    const axiosConfig= {
        method : 'get',
        url : fullExcelUrl,
        // responseType : 'blob',
        data : params,
        params : params,
    };
    try {
        const response = await axios(axiosConfig);
        // const url = window.URL.createObjectURL(new Blob([response.data],{type : 'application/pdf'}));
        const url =response.data.Data.Result.List[0].org_url
        console.log(url)
        const anchor = document.createElement('a');

        anchor.href = url;
        anchor.style.display = 'none';
        anchor.target='_blank'
        // anchor.setAttributeNode('download')
        /*let download = document.createAttribute('download')
        anchor.setAttributeNode(download)*/
        anchor.setAttribute('download', fileName);
        console.log(anchor)
        document.body.appendChild(anchor);
        anchor.click();
    }catch (e) {
        console.log(e);
    }
};